import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, inject, input, signal, viewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { LAUNCH_CALLER, LaunchDialogService } from '@spartacus/storefront';

import { FacetCategory } from '../types';

@Component({
    selector: 'dp-facet-category',
    templateUrl: './facet-category.component.html',
    styleUrls: ['./facet-category.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, NgClass],
    providers: []
})
export class DpFacetCategoryComponent {
  facetCategory = input.required<FacetCategory>();
  elementRef = viewChild<ElementRef>('facetCategoryRef');
  expanded = signal(false);

  readonly #launchDialogService = inject(LaunchDialogService);

  toggleGroup(event: UIEvent): void {
    this.expanded.update((value) => !value);
    event.stopPropagation();
  }

  onOpenFacetCategoryPanel(): void {
    if (this.facetCategory().facets.length) {
      this.#launchDialogService.openDialogAndSubscribe(
        LAUNCH_CALLER.FACET_CATEGORY_PANEL,
        this.elementRef(),
        this.facetCategory().code
      );
    }
  }
}
